module.exports = __webpack_public_path__ + "files/02c382c20e2c1aaf76243aa57b505d87.png";